import type { ReactNode } from 'react';
import { Cloud } from 'lucide-react';
import { site } from '@/site.config';

interface PageShellProps {
  children: ReactNode;
}

export default function PageShell({ children }: PageShellProps) {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <header className="border-b border-white/[0.06]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2.5 group w-fit">
            <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center shadow-lg shadow-blue-600/30">
              <Cloud className="text-white" size={18} />
            </div>
            <span className="text-white font-semibold text-[15px]">{site.name}</span>
          </a>
          <a
            href="/"
            className="text-sm text-slate-400 hover:text-white transition-colors"
          >
            Home
          </a>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-white/[0.06] py-8">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-xs text-slate-600">
          © {new Date().getFullYear()} {site.name}. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
